"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkCard = void 0;

var _react = _interopRequireDefault(require("react"));

var _designSystem = require("@storybook/design-system");

var _theming = require("@storybook/theming");

var _AspectRatio = require("../AspectRatio");

var _styles = require("../shared/styles");

var _LinkWithWrapper = require("../LinkWithWrapper");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var offsetStyles = process.env.NODE_ENV === "production" ? {
  name: "15x5cbk",
  styles: "bottom:0;left:0;position:absolute;right:0;top:0"
} : {
  name: "93do23-offsetStyles",
  styles: "bottom:0;left:0;position:absolute;right:0;top:0;label:offsetStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var StyledAspectRatio = ( /*#__PURE__*/0, _theming.styled)(_AspectRatio.AspectRatio, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['alwaysSlideOnMobile', 'as', 'disableSlide', 'isLoading', 'ratio'].includes(prop);
  },
  target: "e1t1psos1"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['alwaysSlideOnMobile', 'as', 'disableSlide', 'isLoading', 'ratio'].includes(prop);
  },
  target: "e1t1psos1",
  label: "StyledAspectRatio"
})("position:relative;z-index:2;", function (props) {
  return props.isLoading && /*#__PURE__*/(0, _theming.css)(_designSystem.animation.inlineGlow, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledAspectRatio;"));
}, ";");
var BlockLink = ( /*#__PURE__*/0, _theming.styled)(_LinkWithWrapper.LinkWithWrapper, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['backgroundColor', 'isLoading'].includes(prop);
  },
  target: "e1t1psos0"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['backgroundColor', 'isLoading'].includes(prop);
  },
  target: "e1t1psos0",
  label: "BlockLink"
})("color:inherit;display:block;text-decoration:none;background-color:", function (props) {
  return props.isLoading ? _styles.color.light : props.backgroundColor;
}, ";border:1px solid ", _styles.color.border, ";border-radius:", _styles.spacing.borderRadius.small, "px;overflow:hidden;", offsetStyles, " &>*{", offsetStyles, ";}");

var LinkCard = function LinkCard(_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? _styles.color.lightest : _ref$backgroundColor,
      children = _ref.children,
      isLoading = _ref.isLoading,
      href = _ref.href,
      LinkWrapper = _ref.LinkWrapper;
  return /*#__PURE__*/_react["default"].createElement(StyledAspectRatio, {
    isLoading: isLoading,
    ratio: "4/3"
  }, /*#__PURE__*/_react["default"].createElement(BlockLink, {
    href: href,
    LinkWrapper: LinkWrapper,
    backgroundColor: backgroundColor,
    isLoading: isLoading
  }, children));
};

exports.LinkCard = LinkCard;